import { minLength, prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class providerCase extends Resource {
    public override type = 'providerCases';
    
    @prop()
    @required()
    public providerId!: string;

    
    @prop()
    @required()
    public caseId!: string;

    @prop()
    @required()
    public companyJobsNoRequired: boolean = true;

}